import { ModelApiKey } from '../types/models.js'

export const paths = {
  [ModelApiKey.Index]: { path: '' },
  [ModelApiKey.Page]: { path: '' },
  [ModelApiKey.Article]: { path: 'news' },
  [ModelApiKey.Work]: { path: 'work' },
  [ModelApiKey.Job]: { path: 'careers' }
}
